import statCookiesSet from '../utils/statCookiesSet';
import { profileAPI } from '../api';
import statApi from '../api/stat/stat';
import { UserStatus } from '../config/constants';
import { useApp } from '../context/AppContext';

export default () => {
    const { useSendStatsMutation } = statApi;
    const [sendStats] = useSendStatsMutation();
    const { userStatus } = useApp();
    const { data: dataProfile } = profileAPI.useGetShortProfileQuery(undefined, {
        skip: userStatus === UserStatus.Guest,
    });

    return ({
        state,
        setShowBanner,
    }: {
        state: boolean
        setShowBanner?: (state: boolean) => void
    }) => {
        if (setShowBanner) setShowBanner(false);

        statCookiesSet(state);

        if (dataProfile) {
            sendStats({
                msisdn: dataProfile.msisdn,
                accepted: state,
                timestamp: Date.now(),
            })
                .then((res) => {
                    if ('error' in res) statCookiesSet(state);
                });
        }
    };
};
